<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">Assassination</a></p>
<p class="toc"><a href="#/Chapter2#C2">“We Know He Did It. We Just Can’t Prove It”</a></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">A Young Mother’s Brutal Slaying</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">A Daughter Remembers</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">Murder at the Maples Motel</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">Death on “the Corner”</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">Stairway to Heaven</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">A Civil War Veteran’s Slaying Goes Unsolved</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">Holiday Homicide</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">A Need to See Justice Done in His Son’s Murder</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">“I Dream I See Blood”</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">Running with Some Bad People</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">The Murder Season of 1979</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">Cold Case Farm</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">“He Needs to Be Held Accountable”</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">“If the Tables Were Turned and I Were Murdered…”</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">“I Want Them to Sit in Prison Until the Day They Die”</span></p>
<p class="toc"><span href="#/Chapter18#C18" title="Link target outside of Sample">A Muncie Mother Goes Missing</span></p>
<p class="toc"><span href="#/Chapter19#C19" title="Link target outside of Sample">The Killing of “Bobby Blue”</span></p>
<p class="toc"><span href="#/Chapter20#C20" title="Link target outside of Sample">Who’s Got the Files? The Absence of Records Hampers Cold Case Reviews</span></p>
<p class="toc"><span href="#/Chapter21#C21" title="Link target outside of Sample">The Killing of James Tricker Jr.</span></p>
<p class="toc"><span href="#/Chapter22#C22" title="Link target outside of Sample">“What Goes Around…”</span></p>
<p class="toc"><span href="#/Chapter23#C23" title="Link target outside of Sample">“The Proverbial Monster Lurking in the Darkness”</span></p>
<p class="toc"><span href="#/Chapter24#C24" title="Link target outside of Sample">The Cold Case Squad</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?7bae1f1a